import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';
import { AuthenticationService } from '../services/authentication.service';
import { Constants } from '../../models/constants';
import { SnackbarService } from '../../services/snackbar.sevice';
import { Urls } from 'src/app/models/urls';
import { RoleEnum } from '@app/api-module/user-management-api-client-v2';

@Component({
    selector: 'app-login-callback',
    templateUrl: './login-callback.component.html',
    styleUrls: ['./login-callback.component.scss']
})
export class LoginCallbackComponent implements OnInit {
    constructor(
        private readonly router: Router,
        private readonly route: ActivatedRoute,
        private readonly snackBarService: SnackbarService,
        private readonly oAuthService: OAuthService,
        private readonly authenticationService: AuthenticationService
    ) {}

    async ngOnInit(): Promise<void> {
        if (this.route.snapshot.queryParamMap.get('forceLogout') === 'true') {
            this.authenticationService.doLogout();
        }

        // redirected from Auth0 for blocked account
        if (
            (this.route.snapshot.queryParamMap.get('error') === 'unauthorized' ||
                this.route.snapshot.queryParamMap.get('error') === 'access_denied') &&
            this.route.snapshot.queryParamMap.get('error_description') === 'user is blocked'
        ) {
            await this.router.navigate(['/logout']);
            this.snackBarService.openSnackBar(Constants.UserBlockedMessage, SnackbarService.SNACK_BAR_CLASS_ALERT);
            return;
        }

        if (await this.authenticationService.loginWithTokens()) {
            await this.handleLogin();
            return;
        }

        await this.oAuthService.tryLogin(); // Use passed code to get tokens
        if (await this.authenticationService.loginWithTokens()) {
            // Notify authentication service to translate tokens into user object.
            await this.handleLogin();
        } else {
            await this.router.navigate(['/']);
        }
    }

    async handleLogin(): Promise<void> {
        const currentUser = this.authenticationService.getCurrentUser();
        if (currentUser.passwordChangeRequired === true) {
            await this.router.navigate([Urls.PASSWORD_CHANGE]);
        } else {
            const orgCode = [...currentUser.orgs.keys()][0];
            if (
                currentUser.hasRole(RoleEnum.GeneralAccess, orgCode) ||
                currentUser.hasRole(RoleEnum.ClinicalFeedback, orgCode) ||
                currentUser.hasRole(RoleEnum.ImagingRequestViewer, orgCode) ||
                currentUser.hasRole(RoleEnum.ImagingRequestEditor, orgCode) ||
                currentUser.hasRole(RoleEnum.DemandManagement, orgCode)
            ) {
                await this.router.navigate([Urls.DASHBOARD]);
            } else if (currentUser.hasRole(RoleEnum.Admin, orgCode)) {
                await this.router.navigate([Urls.MANAGE_USERS]);
            } else {
                await this.router.navigate([Urls.MY_DETAILS]);
            }
        }
    }
}
